import DialerCreditSlider from './dialer-credit-slider';
import { DialerCreditSliderItem } from './types';

export type DialerCreditSliderProps = {
  creditSliderItems: DialerCreditSliderItem[];
  creditSliderValue: number[];
  setCreditSliderValue: React.Dispatch<React.SetStateAction<number[]>>;
  isLoading: boolean;
  onBuyNow: () => void;
  isBuyNowLoading?: boolean;
  isBuyNowDisabled?: boolean;
};

export default DialerCreditSlider;
